


























import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter, Mutation, namespace } from 'vuex-class';
import CountryFlag from '@/components/CountryFlag.vue';

const I18nModule = namespace('i18n');

@Component({ components: { CountryFlag } })
export default class LanguageSelector extends Vue {
  @Getter
  private readonly availableLocales!: { key: string; value: string }[];

  @Mutation
  private setLanguage: any;

  @I18nModule.Action
  public switchLocale!: any;

  @Prop(String)
  private lang: any;

  public selectorIsOpen = false;

  created() {
    this.changeLang(this.lang);
  }

  changeLang(lang: string) {
    const getLang = lang;
    localStorage.setItem('welcmLanguage', getLang);
    this.setLanguage(getLang);
    this.switchLocale(getLang);
    this.selectorIsOpen = false;
  }

  get selectedLanguage(): { key: string; value: string } | undefined {
    return this.availableLocales.find(x => x.key === this.lang);
  }
}
